export default "__VITE_ASSET__E3sdOf1l__"